module.exports = __webpack_public_path__ + "static/media/Layout15.a3ebe5f7.png";